"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SystemMessage = ({ message }) => {
    const messageStyle = {
        maxWidth: "100%",
        padding: "8px",
        margin: "6px",
        fontSize: "0.9rem",
        color: "rgb(98 14 14)",
        wordBreak: "break-word",
        background: "rgb(0 0 0 / 19%)",
        borderRadius: "6px",
        textAlign: "center",
    };
    const boxStyle = {
        display: "flex",
        flex: "1",
        flexFlow: "column",
        width: "100%",
        margin: 0,
    };
    return (react_1.default.createElement("p", { style: boxStyle },
        react_1.default.createElement("span", { "data-testid": "system", style: messageStyle }, message)));
};
exports.default = SystemMessage;
